import { Button, Skeleton, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router';

import { DashboardCreatedProperty } from '../DashboardCreatedProperty';
import { DashboardMetaProperties } from '../DashboardMetaProperties';
import { useGetDashboard } from '@/api/REST/dashboards';
import { Icon } from '@/components/ui/Icon';
import { PageHeader } from '@/components/ui/PageHeader';
import { routes } from '@/constants/routes';
import { uiIcons } from '@/constants/uiIcons';

export const DashboardPageHeader = ({
  dashboardId,
}: {
  dashboardId: number;
}) => {
  const { t } = useTranslation('dashboard');
  const { state } = useLocation();
  const { data: dashboardData, isLoading: isDashboardLoading } =
    useGetDashboard(dashboardId);

  /*
   * Use manual state passed to Link in DashboardTable columns, instead of relying on window.navigation as it is not widely supported yet.
   * Can be refactored once non-supporting Safari versions get less distribution, see https://caniuse.com/wf-navigation
   */
  const backTo = state?.backTo ?? routes.reporting.base();

  return (
    <Stack direction="row" alignItems="start" justifyContent="space-between">
      {isDashboardLoading ? (
        <Stack gap={3}>
          <Stack direction="row" gap={2}>
            {[0, 1, 2].map((index) => (
              <Skeleton key={index} variant="rounded" width={80} height={12} />
            ))}
          </Stack>
          <Skeleton variant="rounded" width={160} height={26} />
        </Stack>
      ) : (
        dashboardData && (
          <Stack gap={3}>
            <Stack direction="row" gap={2}>
              <DashboardMetaProperties dashboardData={dashboardData} />
              {dashboardData.dashboardType !== 'System' && (
                <DashboardCreatedProperty dashboardData={dashboardData} />
              )}
            </Stack>
            <PageHeader title={dashboardData.name} />
          </Stack>
        )
      )}

      <Button
        component={Link}
        to={backTo}
        variant="text"
        color="secondary"
        startIcon={<Icon name={uiIcons.navigation.back} size="medium" />}
      >
        {t('BackNavigationButton')}
      </Button>
    </Stack>
  );
};
